import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Conditie } from '../dto/conditie';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class ConditieService extends CrudService<Conditie> {

    constructor(injector: Injector) { super(Conditie, injector); }

}
